// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"6421":"css/admin-app.6738","6650":"css/app.6738"}[chunkId] + ".css";
};